import { Injectable } from "@nestjs/common";
import { Code, DataSource } from "typeorm";
import { NeedleModelEntity } from "./entity/needle-model-entity";
import { NeedleModelRepository } from "./repository/needle-model-repository";
import { NeedleModelCreateRequest, NeedleModelModel, NeedleModelResponse } from "@needle-management/shared-models";
import { CommonResponseModel } from "@needle-management/shared-models";

@Injectable()
export class NeedleModelService {
  constructor(
    private dataSource: DataSource,
    private needleModelRepo: NeedleModelRepository,
  ) { }

  async createNeedleModel(reqModel: NeedleModelCreateRequest): Promise<NeedleModelResponse> {
   
    try {
      const resultEntity: NeedleModelEntity[] = [];
      for (const eachNeedleModel of reqModel.needleModel) {
        const existingRecord =await this.needleModelRepo.find({
          where: [
            { needleModel: eachNeedleModel.needleModel },
          ]
        });

        if (existingRecord.length > 0 && !eachNeedleModel.id) {
          return new NeedleModelResponse(false,0, "Needle Model exists");
        }
        const entity = new NeedleModelEntity();
        entity.needleModel = eachNeedleModel.needleModel;
        entity.createdUser = reqModel.userName;
        

        const savedEntity = await this.needleModelRepo.save(entity);
        resultEntity.push(savedEntity);        
      }

      return new NeedleModelResponse(true, 85552, `Needle Model Added Successfully`, resultEntity);
    } catch (error) {
      throw error;
    }
  }

 async updateNeedleModel(reqModel: NeedleModelModel): Promise<NeedleModelResponse> {
  try {
    const existingRecord = await this.needleModelRepo.find({
      where: [
        { needleModel : reqModel.needleModel },
      ]
    });

    if (existingRecord.length > 0 && existingRecord[0].id !== reqModel.id) {
      return new NeedleModelResponse(false, 0, "Needle Model exists");
    }

    const entity = await this.needleModelRepo.findOne({ where: { id: reqModel.id } });
    if (!entity) {
      return new NeedleModelResponse(false, 0, "NeedleModel not found");
    }

    entity.needleModel = reqModel.needleModel;
    // entity.updatedUser = reqModel.userName;
    entity.updatedAt = new Date();

    const savedEntity = await this.needleModelRepo.save(entity);

    return new NeedleModelResponse(true, 85553, `Needle Model Updated Successfully`, [savedEntity]);
  } catch (error) {
    throw error;
  }
}


  async deleteNeedleModel(reqModel: NeedleModelModel): Promise<NeedleModelResponse> {
    if (!reqModel.id) {
      throw new NeedleModelResponse(true,55689, "Please provide needleModel ID");
    }
    const records = await this.needleModelRepo.find({ where: {id:reqModel.id}});
    if (records.length === 0) {
      throw new NeedleModelResponse(true,55689, "No records found");
    }
    await this.needleModelRepo.delete(reqModel.id);
    return new NeedleModelResponse(true, 85552, "NeedleModel Deleted Successfully");
  }
  
  async getAllNeedleModels(): Promise<NeedleModelResponse> {
    try {
      const records = await this.needleModelRepo.find({order:{needleModel:'ASC'}});
      const resultData: NeedleModelModel[] = records.map(data => {
        return new NeedleModelModel(data.needleModel,data.id,data.isActive );
      });
      return new NeedleModelResponse(true, 85552, "Data Retrieved Successfully", resultData);
    } catch (error) {
      if (error ) {
        throw error;
      }
      throw new NeedleModelResponse(true,56465, error.message);
    }
  }
  async getActiveNeedleModel(): Promise<CommonResponseModel> {
    const data = await this.needleModelRepo.find({ where: { isActive: true } });
    if (data.length > 0) {
      return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
    }
    return new CommonResponseModel(true, 1, 'No active Needle Size data found', []);
  }
  

  async activateDeactivateNeedleModel(reqModel: NeedleModelModel): Promise<NeedleModelResponse> {
    const getRecord = await this.needleModelRepo.findOne({ where: {id: reqModel.id}});
    
    if (!getRecord) {
      throw new NeedleModelResponse(true,404, "Record not found");
    }
    const newStatus = !getRecord.isActive; 
    await this.needleModelRepo.update({ id: reqModel.id }, { isActive: newStatus });
    return new NeedleModelResponse(true,newStatus ? 1 : 0,newStatus ? "NeedleModel Activated Successfully" : "NeedleModel Deactivated Successfully");
  }


  async getActiveModels(): Promise<CommonResponseModel> {
    try{
      let data = await this.needleModelRepo.find({where:{isActive:true}});
      if(data.length>0){
        return new CommonResponseModel(true,1,"data retrived successfully. ", data);
      }
      else{
        return new CommonResponseModel(false,0,"no data found. ");
      }
    }
    catch(error){
      return error
    }


  }

  
  
}